// Search for iframes in typography div and wrap them in a video wrapper.

(function ($) {


    // Get the nodelist of all iframe in typography
    var target = document.querySelectorAll('.typography iframe'),
        index,
        max,
        wrapper;

    if (target) {
        for (index = 0, max = target.length; index < max; index++) {
            // Create a div with class video-wrapper and rewrite each iframe in this div


            wrapper = document.createElement('div');
            wrapper.innerHTML = target[index].outerHTML;
            wrapper.setAttribute('class', 'video-wrapper');

            $(wrapper).wrapInner("<div class='video-container'></div>");

            target[index].parentNode.insertBefore(wrapper, target[index]);
            target[index].parentNode.removeChild(target[index]);



        }
    }

}(jQuery));
